export default {
  title: 'Acceso no autorizado',
  root: 'Ir al inicio',
};
